// src/components/SignOut.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./SignOut.css";

function SignOut() {
  const navigate = useNavigate();

  const handleBackdropClick = () => {
    // Close modal: go back or go home if no history
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  const handleStay = () => {
    handleBackdropClick();
  };

  const handleConfirm = () => {
    navigate("/signout-confirm");
  };

  return (
    <div className="tm-signout-backdrop" onClick={handleBackdropClick}>
      <div
        className="tm-signout-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="tm-signout-title">Sign Out</h2>
        <p className="tm-signout-text">
          Are you sure you would like to sign out?
        </p>

        <div className="tm-signout-actions">
          <button
            type="button"
            className="tm-signout-btn tm-signout-btn-primary"
            onClick={handleConfirm}
          >
            Yes, sign me out
          </button>
          <button
            type="button"
            className="tm-signout-btn tm-signout-btn-secondary"
            onClick={handleStay}
          >
            No, stay signed in
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignOut;
